import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SaleTypeService } from '../proxy/controlling/controllers/sale-type.service';
import { CurrencyService } from '../proxy/controlling/controllers/currency.service';
import { CustomerService } from '../proxy/controlling/controllers/customer.service';
import { PurchaseOrderService } from '../proxy/controlling/controllers/purchase-order.service';
import { DocumentTypeService } from '../proxy/controlling/controllers/document-type.service';
import { ProfitCenterService } from '../proxy/controlling/controllers/profit-center.service';
import { CompanyCodeService } from '../proxy/controlling/controllers/company-code.service';
import { SaleOrderParameterValueService } from '../proxy/controlling/controllers/sale-order-parameter-value.service';
import { SapPlantService } from '../proxy/controlling/controllers/sap-plant.service';

FieldBuilder.setNamespace('Controlling');

export const SALEORDERPARAMETRIZATION_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'termsOfPaymentParameterValueId',
    'Entity.SaleOrderParametrization.DivisionParameterValue',
    SaleOrderParameterValueService
  )
    .displayFromNested('termsOfPaymentParameterValue.name')
    .sortBy('termsOfPaymentParameterValue.name')
    .build(),
  FieldBuilder
    .text('headerText', 'Entity.SaleOrderParametrization.HeaderText')
    .build(),
  FieldBuilder
    .number('contractId', 'Entity.SaleOrderParametrization.ContractId')
    .build(),
  FieldBuilder.foreignKey(
    'saleTypeId',
    'Entity.SaleType',
    SaleTypeService
  )
    .required()
    .displayFromNested('saleType.name')
    .sortBy('saleType.name')
    .build(),
  FieldBuilder.foreignKey(
    'currencyId',
    'Entity.Currency',
    CurrencyService
  )
    .required()
    .displayFromNested('currency.name')
    .sortBy('currency.name')
    .build(),
  FieldBuilder.foreignKey(
    'customerId',
    'Entity.Customer',
    CustomerService
  )
    .displayFromNested('customer.name')
    .sortBy('customer.name')
    .build(),
  FieldBuilder.foreignKey(
    'purchaseOrderId',
    'Entity.PurchaseOrder',
    PurchaseOrderService
  )
    .displayFromNested('purchaseOrder.name')
    .sortBy('purchaseOrder.name')
    .build(),
  FieldBuilder.foreignKey(
    'documentTypeId',
    'Entity.DocumentType',
    DocumentTypeService
  )
    .required()
    .displayFromNested('documentType.name')
    .sortBy('documentType.name')
    .build(),
  FieldBuilder.foreignKey(
    'profitCenterId',
    'Entity.ProfitCenter',
    ProfitCenterService
  )
    .displayFromNested('profitCenter.sapCode')
    .sortBy('profitCenter.sapCode')
    .build(),
  FieldBuilder.foreignKey(
    'companyCodeId',
    'Entity.CompanyCode',
    CompanyCodeService
  )
    .displayFromNested('companyCode.name')
    .sortBy('companyCode.name')
    .build(),
  FieldBuilder.foreignKey(
    'sapPlantId',
    'Entity.Plant',
    SapPlantService
  )
    .displayFromNested('sapPlant.name')
    .sortBy('sapPlant.name')
    .build(),
  FieldBuilder.foreignKey(
    'distributionChannelParameterValueId',
    'Entity.SaleOrderParametrization.DistributionChannelParameterValue',
    SaleOrderParameterValueService
  )
    .required()
    .displayFromNested('distributionChannelParameterValue.name')
    .sortBy('distributionChannelParameterValue.name')
    .build(),
  FieldBuilder.foreignKey(
    'divisionParameterValueId',
    'Entity.SaleOrderParametrization.DivisionParameterValue',
    SaleOrderParameterValueService
  )
    .required()
    .displayFromNested('divisionParameterValue.name')
    .sortBy('divisionParameterValue.name')
    .build(),
];

export const SALEORDERPARAMETRIZATION_CONFIG = {
  entityName: 'SaleOrderParametrization',
  localizationKey: 'Controlling::Entity.SaleOrderParametrization',
  fields: SALEORDERPARAMETRIZATION_FIELDS,
  permission: 'ControllingLiquidations.SaleOrderParametrizations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
